module.exports = __webpack_public_path__ + "images/136_4096.jpg";